import {
  AddBankNameParams,
  AddBankNameResponse,
  GetBankListParams,
  GetBankListResponse,
} from '@nxsys/types/api/bank';
import axios from '../axios';
import { endPoints } from '../endpoints';
import { BankVerificationResponse } from '@nxsys/utils/bank-verification';
import { BankCheckInput } from '@nxsys/utils/bulk-bank-verification';

const url = import.meta.env.VITE_URL_VERIFY_BANK ?? '';
const Key = import.meta.env.VITE_VERIFY_BANK_API_KEY ?? '';

export const verifyBankAccountsBatch = async (
  accounts: BankCheckInput[],
  signal: AbortSignal,
): Promise<BankVerificationResponse[]> => {
  if (!url || !Key) throw new Error('Bank verification is not configured.');
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal.addEventListener('abort', abort);
  if (signal.aborted) controller.abort();
  const timeout = setTimeout(abort, 30000);
  try {
    const response = await fetch(url, {
      method: 'POST',
      signal: controller.signal,
      body: new URLSearchParams({
        Key,
        AccountNumbers: accounts
          .map((account) => account.accountNumber)
          .join(','),
        SortCodes: accounts.map((account) => account.sortCode).join(','),
      }),
    });
    if (!response.ok)
      throw new Error(
        `Bank verification service returned HTTP ${response.status}.`,
      );
    const body = await response.json();
    if (
      !Array.isArray(body.Items) ||
      body.Items.some((item: unknown) => !item || typeof item !== 'object')
    ) {
      throw new Error('Unexpected bank verification response.');
    }
    return body.Items;
  } catch (error) {
    if (controller.signal.aborted)
      throw new Error(
        'Verification interrupted. Results may be unknown; do not retry automatically.',
      );
    throw error;
  } finally {
    clearTimeout(timeout);
    signal.removeEventListener('abort', abort);
  }
};

export const verifyBankAccount = ({ params, cb }: any) => {
  const { AccountNumbers, SortCodes } = params;
  let query = '';
  query += '&Key=' + encodeURIComponent(Key);
  query += '&AccountNumbers=' + encodeURIComponent(AccountNumbers);
  query += '&SortCodes=' + encodeURIComponent(SortCodes);
  const http = new XMLHttpRequest();
  http.open('POST', url, true);
  http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  http.onreadystatechange = function () {
    if (http.readyState === 4 && http.status === 200) {
      const response = JSON.parse(http.responseText);
      // Test for an error
      const { Items } = response;
      cb(Items[0]);
      // if (response.Items.length === 1 && typeof(response.Items[0].Error) !== "undefined") {
      //   // Show the error message
      //   // alert(response.Items[0].Description);
      //   cb({ error: response.Items[0].Description });
      // } else {
      //   // Check if there were any items found
      //   if (response.Items.length === 0)
      //       alert("Sorry, there were no results");
      //   else {
      //     const { Items } = response;
      //     cb(Items[0]);
      //   }
      // }
    }
    cb();
  };
  http.send(query);
};

export const getBankListApi = async (
  params?: GetBankListParams,
): Promise<GetBankListResponse> => {
  const response = await axios.get(`${endPoints.getBankList}`, { params });
  return response.data;
};

export const addBankNameApi = async (
  params: AddBankNameParams,
): Promise<AddBankNameResponse> => {
  const response = await axios.post(`${endPoints.getBankList}`, params);
  return response.data;
};

export default {
  verifyBankAccount,
};
